export const PROCEED_EVENT_NAME = 'proceed'
export const EDIT_EVENT_NAME = 'edit'
export const DELETE_EVENT_NAME = 'delete'
export const ADD_EVENT_NAME = 'add'
export const TRAVELERS_LIMIT_OUTBOUND = 30
// TODO: move to shared layer
export const HOLDER_ID = 'holder'
